import { atom } from "recoil";

export const rentDetailsFormDataAtom = atom({
  key: "rentDetailsFormDataAtom",
  default: {},
});
